import { render, staticRenderFns } from "./ManageClaims.vue?vue&type=template&id=0eb19c4f&"
import script from "./ManageClaims.vue?vue&type=script&lang=js&"
export * from "./ManageClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports